import { render, staticRenderFns } from "./partyBuildingDetail.vue?vue&type=template&id=700678f8&scoped=true"
import script from "./partyBuildingDetail.vue?vue&type=script&lang=js"
export * from "./partyBuildingDetail.vue?vue&type=script&lang=js"
import style0 from "./partyBuildingDetail.vue?vue&type=style&index=0&id=700678f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700678f8",
  null
  
)

export default component.exports